module.exports = __webpack_public_path__ + "static/media/Морева М.А., Орлов С.С..4445280e.pdf";